import common from '../common';
import paper from 'paper';

export default class Drawing extends PIXI.Container {
    constructor() {
        super();

        this.signals = {
            beginPath: new P3.utils.MiniSignal(),
            pathTo: new P3.utils.MiniSignal(),
            endPath: new P3.utils.MiniSignal()
        };
        this.style = {
            fill: {
                color: '#FF0000',
                stroke: true
            },
            stroke: {
                color: '#000000',
                width: 4
            }
        };

        this._enabled = true;
        this._canvas = null;
        this._drawing = false;
        this._path = null;
        this._compoundPath = null;

        this._paths = {};
        this._currentSlotName = '';

        this._booleanDest = '';
        this._closePath = false;

    }

    init() {
        this._createCanvas();

        paper.setup(this._canvas[0]);
        this.update();
    }

    destroy() {
        paper.remove();
        this._canvas.remove();

        common.canvas = this._canvas;
        common.paper = paper;

        P3.utils.destroyAllSignals(this.signals);

        super.destroy({children: true});
    }

    update() {
        const mat = paper.view.matrix;
        mat.a = this.worldTransform.a;
        mat.b = this.worldTransform.b;
        mat.c = this.worldTransform.c;
        mat.d = this.worldTransform.d;
        mat.tx = this.worldTransform.tx;
        mat.ty = this.worldTransform.ty;
        mat.transform = mat;
    }

    resize() {
        paper.view.viewSize = new paper.Size(P3.View.width, P3.View.height);
    }

    beginSlot(booleanDest, slotName = '') {
        this._compoundPath = new paper.CompoundPath();
        this._compoundPath.strokeColor = this.style.stroke.color;
        this._compoundPath.strokeWidth = this.style.stroke.width;
        this._compoundPath.strokeJoin = 'round';
        this._compoundPath.strokeCap = 'round';
        // this._compoundPath.dotted = this.style.stroke.dotted; //Dotted gives an extra dot when drawn, so will show up when drawing e.g. freckles

        this._currentSlotName = slotName.toString();
        // this._booleanPaths[slotName] = null;
        this._booleanDest = this.style.fill.enabled ? booleanDest : null;

       // console.warn(booleanDest);

        this._closePath = this.style.fill.enabled;

    }

    beginPath(point) {
        if (!this._path) {
            const path = new paper.Path();
            path.strokeColor = this.style.stroke.pathStrokeColor ? this.style.stroke.pathStrokeColor : this.style.stroke.color;
            path.strokeWidth = this.style.stroke.width;
            path.strokeJoin = 'round';
            path.strokeCap = 'round';
            path.moveTo(point);
            this._path = path;
        }
    }

    pathTo(point) {
        if (this._path) {
            const path = this._path;
            this._lastPoint = point;
            path.lineTo(point);
        }
    }

    endPath() {
        if (this._path) {
            this._path.simplify(common.config.drawing.simplify);
            this._closePath && this._path.closePath();

            if (this.style.fill.enabled) {
                this._path.fillColor = this.style.fill.color;

                if (this._path.fillColor.gradient) {
                    this._path.fillColor.gradient.origin = this._path.bounds.leftCenter;
                    this._path.fillColor.gradient.destination = this._path.bounds.rightCenter;

                    this._path.fillColor.origin = this._path.bounds.leftCenter;
                    this._path.fillColor.destination = this._path.bounds.rightCenter;
                }

                this._compoundPath.fillColor = this._path.fillColor;
            }

            this._path.strokeWidth = this.style.fill.stroke ? this._path.strokeWidth : 0;

            this._compoundPath.addChild(this._path);
            this._path = null;
        }
        return this._compoundPath;
    }

    _createCanvas() {
        this._canvas = $('<canvas/>', {
            id: 'paper-canvas',
            width: '100%',
            height: '100%',
            hidpi: 'off',
            css: {
                'position': 'absolute',
                'left': 0 + 'px',
                'right:': 0 + 'px',
                'top': 0 + 'px',
                'bottom': 0 + 'px',
                'pointer-events': 'none'
            }
        });
        P3.View.holder.appendChild(this._canvas[0]);
        this._canvas.insertAfter('#pixi-canvas');
    }

    onPointerDown(event) {
        if (!this._enabled)
            return;

        const point = event.data.getLocalPosition(this);
        point.set(point.x, point.y);

        this._drawing = true;
        this.beginPath(point);

        this.signals.beginPath.dispatch(this);
    }

    onPointerMove(event) {
        if (!this._enabled)
            return;

        const point = event.data.getLocalPosition(this);
        point.set(point.x, point.y);

        if (this._drawing) {
            this.pathTo(point);
        }
    }

    onPointerUp() {
        if (!this._enabled)
            return;

        this._drawing = false;
        let path = this.endPath();

        if (this._booleanDest) {
            for (const key in this._paths) {
                if (this._booleanDest === key) {

                    let obj = this._paths[key];
                    let boolPath = obj.intersect(path);
                    path.remove();

                    path = new paper.CompoundPath();
                    path.strokeColor = this.style.stroke.color;
                    path.fillColor = this.style.fill.color;
                    path.strokeWidth = this.style.stroke.width;
                    path.strokeJoin = 'round';
                    path.strokeCap = 'round';

                    boolPath.addTo(path);

                }
            }
        }

        this._paths[this._currentSlotName] = path;
        path && this.signals.endPath.dispatch(this, path);

    }

    get enabled() {
        return this._enabled;
    }

    set enabled(value) {
        this._enabled = value;
        if (this._drawing) {
            this.onPointerUp(null);
        }
    }

    set grouped(value) {
        this._groupedDrawing = value;
    }

    /*
    get useRegularMasking() {
        return this._useRegularMasking;
    }

    set useRegularMasking(value) {
        this._useRegularMasking = value;
    }

     */

    get booleanDest() {
        return this._booleanDest;
    }
}
